import { render, staticRenderFns } from "./ProductRegistration.vue?vue&type=template&id=f4052f54&"
import script from "./ProductRegistration.vue?vue&type=script&lang=ts&"
export * from "./ProductRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports